import React, { Component } from "react";
import PropTypes from "prop-types";
import onClickOutside from "react-onclickoutside";
import classcat from "classcat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "../../../infrastructure/translate/localization";
import { downloadTemplateFilterFile } from "../../../usecases/employees/download-template-filter-file";

import "./filter-csv-button.scss";

class FilterCsvButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      active: false,
    };
  }

  clearSelection = () => {
    const { clearFilter } = this.props;
    this.setState({ listOpen: false, active: false });
    clearFilter();
  };

  handleUploadFile = (e) => {
    const { uploadFile } = this.props;
    this.setState({ active: true });
    this.handleClickOutside();
    uploadFile(e);
  };

  downloadTemplate = () => {
    downloadTemplateFilterFile();
  };

  handleClickOutside() {
    this.setState({ listOpen: false });
  }

  toggleList() {
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  }

  render() {
    const { status } = this.props;
    const { listOpen, active } = this.state;

    return (
      <div className={classcat(["dd-csv-wrapper", { active }])}>
        {active && (
          <div
            className="dd-csv-clear"
            onClick={this.clearSelection}
            role="presentation"
          >
            <span className="icon-clear">
              <FontAwesomeIcon icon="times" />
            </span>
          </div>
        )}

        <div
          tabIndex={0}
          className="dd-csv-header"
          role="button"
          onKeyPress={() => this.toggleList()}
          onClick={() => this.toggleList()}
        >
          <div className={classcat(["dd-csv-header__title", { active }])}>
            <p className="dd-csv-header__title">
              {translate("employees-section.filters-section.filter-csv")}
            </p>
          </div>
          <div className={classcat(["dd-csv-header__action", `${status}`])}>
            {status === "info" && <FontAwesomeIcon icon="info-circle" />}
            {status === "success" && <FontAwesomeIcon icon="check-circle" />}
            {status === "warning" && (
              <FontAwesomeIcon icon="exclamation-circle" />
            )}
            {status === "error" && (
              <FontAwesomeIcon icon="exclamation-circle" />
            )}
          </div>
        </div>

        {listOpen && (
          <div className="dd-csv-list">
            <div className="dd-csv-list-header">
              <button
                type="button"
                className="item"
                onClick={() => this.toggleList()}
              >
                <span className="title">
                  {translate("employees-section.filters-section.filter-csv")}
                </span>
                <FontAwesomeIcon icon="times" />
              </button>
            </div>

            <div className="dd-csv-list-item">
              <div className="item">
                <div className="item-info">
                  <FontAwesomeIcon icon="info-circle" />
                </div>
                <div>
                  <p>
                    {translate(
                      "employees-section.filters-section.filter-csv-description-1"
                    )}
                  </p>
                  <p>
                    {translate(
                      "employees-section.filters-section.filter-csv-description-2"
                    )}
                  </p>

                  <ul>
                    <li>
                      <div className="decoration" />
                      <p>
                        <span>
                          {translate(
                            "employees-section.filters-section.filter-file-by-legal"
                          )}
                        </span>{" "}
                        {translate(
                          "employees-section.filters-section.filter-file-by-legal-2"
                        )}
                      </p>
                    </li>

                    <li>
                      <div className="decoration" />
                      <p>
                        <span>
                          {translate(
                            "employees-section.filters-section.filter-file-by-email"
                          )}
                        </span>
                      </p>
                    </li>
                    <li>
                      <div className="decoration" />
                      <p>
                        <span>
                          {translate(
                            "employees-section.filters-section.filter-file-by-internal-id"
                          )}
                        </span>{" "}
                        {translate(
                          "employees-section.filters-section.filter-file-by-internal-id-2"
                        )}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="dd-csv-call-action">
              <button
                type="button"
                className="cob-btn btn-primary"
                onClick={() => this.upload.click()}
              >
                <span>{translate("upload-employees-section.upload-csv")}</span>
              </button>
              <input
                id="workaround-upload"
                accept="text/csv"
                type="file"
                ref={(ref) => {
                  this.upload = ref;
                }}
                style={{ display: "none" }}
                onChange={(e) => this.handleUploadFile(e)}
              />
            </div>
            <div className="dd-csv-call-action">
              <div
                className="link"
                onClick={() => this.downloadTemplate()}
                role="presentation"
              >
                {translate(
                  "employees-section.filters-section.download-csv-template"
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

FilterCsvButton.propTypes = {
  uploadFile: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default onClickOutside(
  FilterCsvButton,
  FilterCsvButton.handleClickOutside
);
